import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import ProductButtons from './ProductButtons';
import ProductInfo from './ProductInfo';

const ProductContent = ({ product, onAngebotButtonClick, isContactForm = false }) => {
    const { kreditbetrag, rate, laufzeit, sollzins, fixlaufzeit, institut, description, bank_id, result_id } = product;

    const img_src = (() => {
      return 'logo.png';
      console.log("bank_id: " + bank_id);
      switch (parseInt(bank_id)) {
      case 1:
        return 'bank_austria.png';
      case 2:
        return 'bawag_psk.png';
      case 3:
        return 'generali.jpg';
      case 4:
        return 'hypo_lb_noe.jpg';
      case 6:
        return 's_bausparkasse.png';
      case 7:
        return 'raiffeisen_bausparkasse.png';
      case 8:
        return 'start_bausparkasse.png';
      case 9:
        return 'wuestenrot.jpg';
      case 10:
        return 'volksbank_wien.png';
      case 11:
        return 'oberbank.jpg';
      // add more cases for other bank IDs
      default:
        return 'logo.png';
      }
    })();

    let test_color = "#FFF";

  const handleAngebotButtonClick = () => {
    onAngebotButtonClick(product);
    test_color = "#6A8BAC";

  }
  const handleMehrButtonClick = () => {
    setMoreActive(!moreActive);
  }

  const formatEuroNumber = (value) => {
    return value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const [moreActive, setMoreActive] = useState(false);



  return (
      <div className="card mb-4" style={{backgroundColor: test_color}}>
        <div className="card-body">
        <div className="row align-items-center">
          {/* Column 1: Icon */}{!isContactForm ?
          <div className="col-md-2 col-sm-6 text-center">
            <div className="icon-container">
                <img style={{width: 180, paddingLeft:40}} src={process.env.PUBLIC_URL + img_src} />
            </div>
          </div> : ""}
          {/* Vertical Line */}
          {!isContactForm ? <div className="col-md-1 vertical-line"></div> : "" }

          {/* Column 2: Product Data */}{!isContactForm ?
          <div className="col-md-4 product-text col-sm-6 text-center">
            <div className="row" style={{paddingTop: 15}}>
              <div className="col">
                <p>
                <strong>{formatEuroNumber(kreditbetrag)} €</strong> <br />
                <small>Ihr Kreditbetrag inkl. Gebühren</small>
                </p>
                <p>
                <strong> {formatEuroNumber(rate)} €</strong><br />
                <small>Ihre monatliche Rate</small>
                </p>
              </div>
              <div className="col">
                <p>
                <strong>{laufzeit} Monate</strong> <br />
                <small>Laufzeit</small>
                </p>
                <p>
                  <strong>{sollzins.toFixed(3)}% p.A.</strong><br />
                  <small>Zinssatz</small>
                </p>
              </div>
            </div>
          </div> :
          <div className="col-md-7 product-text col-sm-6 text-center">
            <div className="row" style={{paddingTop: 15}}>
              <div className="col">
                <p>
                <strong>{formatEuroNumber(kreditbetrag)} €</strong> <br />
                <small>Ihr Kreditbetrag inkl. Gebühren</small>
                </p>
                <p>
                <strong> {formatEuroNumber(rate)} €</strong><br />
                <small>Ihre monatliche Rate</small>
                </p>
              </div>
              <div className="col">
                <p>
                <strong>{laufzeit} Monate</strong> <br />
                <small>Laufzeit</small>
                </p>
                <p>
                  <strong>{sollzins.toFixed(3)}% p.A.</strong><br />
                  <small>Zinssatz</small>
                </p>
              </div>
            </div>
          </div> }

          {/* Vertical Line */}
          {!isContactForm ? <div className="col-md-1 vertical-line"></div> : "" }

          {/* Column 3: Product Buttons */}
          <div className="col-md-4">
            <div className="product-title">
                <p className="product-p1"><font className="product-p1-red">{fixlaufzeit >12 ? fixlaufzeit/12 + " Jahre fix" : ((fixlaufzeit < 12 && fixlaufzeit > 0) ? fixlaufzeit + " Monate" : "Variabel")}</font>{fixlaufzeit >12 ? " - danach variabel verzinst" : ""}</p>
                {/*}<p className="product-p2">{institut} - {description}</p>*/}
                <p className="product-p2">
                  Wohnkredit mit hypothekarischer Besicherung{' '}
                  {result_id && <small>(Produkt-ID {result_id})</small>}
                </p>
            </div>
            {!isContactForm ? <div className="">
              <ProductButtons onAngebotButtonClick={handleAngebotButtonClick} onMehrButtonClick={handleMehrButtonClick}/>
              {/* Render ProductButtons for actions */}
              {/* Assuming ProductButtons component contains action buttons */}
            </div> : ""}
          </div>
        </div>
        {moreActive ?

          <ProductInfo product_data={product}/>
        :""}
      </div>
    </div>
  );
};

export default ProductContent;
